var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",attrs:{"id":"adsModal","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('span',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.ads.url}},[_c('img',{staticClass:"img-fluid",attrs:{"id":"img01","src":_vm.ads.image}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }